import { useLocation } from 'react-router-dom';

export function generateToken() {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (var i = 15; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}

export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname

export function GetURLParams(param) {
    const search = useLocation().search;
    const params = new URLSearchParams(search);
    return params.get(param)
}

export function formateoCifras(numero) {
    var format = comillasFix(numero, false);
    if (numero / 1000000 >= 1) {
        format = comillasFix(Math.round(numero / 1000000 * 100) / 100, true) + 'M';
    }
    else if (numero / 10000 >= 1) {
        format = comillasFix(Math.round(numero / 1000 * 100) / 100, true) + 'K';
    }
    return format;
}

export function comillasFix(y, isDecimal, numDecimal = 2) {
    let isNegative = (y < 0) ? "-" : "";
    //numberformat: function ( y, decimals) {
    var decimals = numDecimal;
    y += ''; // por si pasan un numero en vez de un string
    y = parseFloat(y.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto

    decimals = decimals || 0; // por si la variable no fue fue pasada

    // si no es un numero o es igual a cero retorno el mismo cero
    if (isNaN(y) || y === 0)
        return parseFloat(0).toFixed(decimals);

    // si es mayor o menor que cero retorno el valor formateado como numero
    y = '' + y.toFixed((isDecimal) ? (decimals) : 0);

    var y_parts = y.split('.'),
        regexp = /(\d+)(\d{3})/;

    while (regexp.test(y_parts[0]))
        y_parts[0] = y_parts[0].replace(regexp, '$1' + ',' + '$2');

    //return y_parts.join('.');
    //};
    return isNegative + y_parts.join('.').toString();
}


export function desnulear(objetoNulo) {
    if (objetoNulo.data === null) {
        objetoNulo.data = {};
        objetoNulo.data.graph = [];
        objetoNulo.data.options = [];
    }
    return objetoNulo;
}


export function parcharTabla(objetoAParchar) {

    objetoAParchar.data.table = objetoAParchar.data;
    objetoAParchar.data.data = null;

    return objetoAParchar;
}

export const monthNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun",
    "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
];

export const monthFullNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export function formaterDate(date, separator = "/") {
    return ((date.getDate() > 9 ? date.getDate() : ("0" + date.getDate()))) + separator + (((date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : ("0" + (date.getMonth() + 1)))) + separator + date.getFullYear();
}

export function transformToDate(date, separator = "/") {
    return new Date(date.split(separator)[2], date.split(separator)[1] - 1, date.split(separator)[0]);
}

export function getHeaderMonth(monthNumber, anio, aditionalMonths, isCumplimiento = false) {
    let headerName = '';
    if ((monthNumber + aditionalMonths) > 12) headerName = monthNames[(monthNumber - 1) + aditionalMonths - 12] + ' ' + (anio + 1);
    else headerName = monthNames[(monthNumber - 1) + aditionalMonths] + ' ' + anio;
    if (isCumplimiento) headerName += "-" + (anio - 1);
    return headerName;
}

export function add_years(dt, n) { return new Date(dt.setFullYear(dt.getFullYear() + n)); }

export function setClassDiferenceTable(value, isPercent = true) {
    const classBadge = (value < 0) ? "fw-bolder text-danger ms-1" : (value > 0 ? "fw-bolder text-success ms-1" : "")
    return (
        <>
            <span className={classBadge}>

                {comillasFix(value, true)}{isPercent ? "%" : ""}</span>
        </>
    )
}

export function setClassVariationDashboard(value) {
    const classBadge = (value < 0) ? "fw-bolder text-danger ms-1" : (value > 0 ? "fw-bolder text-success ms-1" : "");
    const arrowPath = (value < 0) ?
        <>
            <span className="svg-icon svg-icon-5 svg-icon-danger ms-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="11" y="18" width="13" height="2" rx="1" transform="rotate(-90 11 18)" fill="black"></rect>
                    <path d="M11.4343 15.4343L7.25 11.25C6.83579 10.8358 6.16421 10.8358 5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75L11.2929 18.2929C11.6834 18.6834 12.3166 18.6834 12.7071 18.2929L18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25C17.8358 10.8358 17.1642 10.8358 16.75 11.25L12.5657 15.4343C12.2533 15.7467 11.7467 15.7467 11.4343 15.4343Z" fill="black"></path>
                </svg>
            </span>  </> :
        (value > 0 ?
            <>
                <span className="svg-icon svg-icon-5 svg-icon-success ms-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)" fill="black"></rect>
                        <path d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z" fill="black"></path>
                    </svg>
                </span>  </>
            : <></>
        )

    return (
        <>
            <span className={classBadge}>
                {arrowPath}

                {comillasFix(Math.abs(value), true, 0)}%</span>
        </>
    )
}

export function getListUnidadesEconomicas(todos) {
    let UnidadesEconomicas = {
        "defaultId": "3",
        "list": [
            {
                "value": "3",
                "label": "Santa Anita"
            },
            {
                "value": "2",
                "label": "Arequipa"
            },
            {
                "value": "6",
                "label": "Chiclayo"
            },
            {
                "value": "7",
                "label": "Iquitos"
            },
            {
                "value": "8",
                "label": "San Juan de Lurigancho"
            }
        ]
    }
    if (todos) {
        UnidadesEconomicas.list.unshift({
            "value": "0",
            "label": "Todas"
        })
    }
    return UnidadesEconomicas;
}

export const getAnioComparativo = () => ((localStorage.getItem('anioComparativo')) ? localStorage.getItem('anioComparativo') : 2019)

export const dateComparator = (date1, date2) => {
    var date1Number = _monthToNum(date1);
    var date2Number = _monthToNum(date2);

    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }

    return date1Number - date2Number;
}

// HELPER FOR DATE COMPARISON
function _monthToNum(date) {
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }

    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);

    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    // 29/08/2004 => 20040829
    return result;
}

export const sumColumns = (params, setState = null) => {
    let total = 0;
    params.values.forEach(value => total += value);
    if (setState) setState(total)
    return total.toFixed(2);
}

export const createCustomDateFilterParams = () => {
    const customDateComparator = (filterLocalDateAtMidnight, cellValue) => {

        const cellDate = new Date(cellValue);

        if (cellDate < filterLocalDateAtMidnight) {
            return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
            return 1;
        }
        return 0;
    };

    return {
        comparator: customDateComparator,
        minValidYear: 2000,
        maxValidYear: 2100,
        inRangeFloatingFilterDateFormat: 'DD/MM/YYYY',
        inRangeInclusive: true,
    };
};

export const createCustomDateStringFilterParams = () => {
    const customDateComparator = (filterLocalDateAtMidnight, cellValue) => {

        const parts = cellValue.split('/');

        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);

        const cellDate = new Date(year, month - 1, day);

        if (cellDate < filterLocalDateAtMidnight) {
            return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
            return 1;
        }
        return 0;
    };

    return {
        comparator: customDateComparator,
        minValidYear: 2000,
        maxValidYear: 2100,
        inRangeFloatingFilterDateFormat: 'DD/MM/YYYY',
        inRangeInclusive: true,
    };
};